// extracted by mini-css-extract-plugin
export default {"banner":"DOIIwj","title":"Vx4KL5","icons":"sb0ytU","phone":"EDUSLt","qr-code":"ZEDdK0"};